module.exports = __webpack_public_path__ + "static/media/IconTemplates_-58.e394ea02.svg";